import { render, staticRenderFns } from "./CoachSearch.vue?vue&type=template&id=060b978b&scoped=true&"
import script from "./CoachSearch.vue?vue&type=script&lang=js&"
export * from "./CoachSearch.vue?vue&type=script&lang=js&"
import style0 from "./CoachSearch.vue?vue&type=style&index=0&id=060b978b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060b978b",
  null
  
)

export default component.exports